import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _9kPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"9k_plus"}/>
}
